import React from 'react'
import { Card, CardBody, Col } from 'reactstrap'
import CommonCardHeader from '../../../Utils/CommonComponents/CommonCardHeader/CommonCardHeader'
import { monthlyDropdownList } from '../../../Data/Dashboard/Default'
import { Badges, H4, P } from '../../../AbstractElements'
import { totalProfitChart } from '../../../Data/Dashboard/Ecommerce'
import ReactApexChart from 'react-apexcharts'

export default function NetIncome() {
    return (
        <Col xxl={6} xl={5} md={7} sm={6} className="box-col-5">
            <Card className="total-profit-chart overflow-hidden">
                <CommonCardHeader headClass="pb-0 card-no-border" mainTitle dropDownList={monthlyDropdownList} title={"Net Income "} />
                <CardBody className="p-0">
                    <div className="profit-goal">
                        <H4>{'$56,365.65 '}
                            <Badges color='secondary' className="ms-3">{'New'}</Badges>
                        </H4>
                        <P>{'Net Income'}</P>
                    </div>
                    <div id="total-profit">
                        <ReactApexChart options={totalProfitChart} series={totalProfitChart.series} type='bar' height={280} />
                    </div>
                </CardBody>
            </Card>
        </Col>
    )
}
